function runCalendarDate(run) {
  const value = run?.run_date || run?.completed_at || run?.started_at;
  return typeof value === "string" ? value.slice(0, 10) : "";
}

function runCompletionTime(run) {
  const value = run?.completed_at || run?.run_date || run?.started_at;
  const timestamp = typeof value === "string" ? Date.parse(value) : Number.NaN;
  return Number.isFinite(timestamp) ? timestamp : null;
}

export function getLocalReportingPeriod(runs, selectedRunId) {
  if (!Array.isArray(runs) || runs.length === 0) return null;
  return runs.find((run) => run.run_id === selectedRunId) || runs[0];
}

export function getEarlierLocalRuns(runs, currentRun) {
  const currentDate = runCalendarDate(currentRun);
  if (!currentDate || !Array.isArray(runs)) return [];

  return runs
    .filter((run) => {
      const runDate = runCalendarDate(run);
      if (run.run_id === currentRun.run_id || !runDate || runDate > currentDate) return false;
      if (runDate < currentDate) return true;
      const candidateTime = runCompletionTime(run);
      const currentTime = runCompletionTime(currentRun);
      return candidateTime !== null && currentTime !== null && candidateTime < currentTime;
    })
    .sort((left, right) => {
      const dateDifference = runCalendarDate(right).localeCompare(runCalendarDate(left));
      if (dateDifference !== 0) return dateDifference;
      return (runCompletionTime(right) ?? 0) - (runCompletionTime(left) ?? 0);
    });
}

export function getEarlierLocalRun(runs, currentRun) {
  return getEarlierLocalRuns(runs, currentRun)[0] || null;
}
